import RegisterBackOffice from './register';

export default RegisterBackOffice;
